import React from "react";
import { useProvider } from "../components/StateProvider";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Login from "./Login";
import Dashboard from "../components/Dashboard";

const App = () => {
  const { user } = useProvider();
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          {!user ? <Login /> : <Dashboard />}
        </Route>
      </Switch>
    </Router>
  );
};

export default App;
